import React, { FC, useEffect, useRef, useState } from "react";
import styles from "./Dropdown.module.scss";
import { DropdownItemType, DropdownPosition, DropdownTypes } from "./Dropdown.types";
import { useOnClickOutside } from "../../hooks";

const Dropdown: FC<DropdownTypes> & { Item: typeof DropdownItem } = ({
                                                                         open,
                                                                         anchorElement,
                                                                         children,
                                                                         placement,
                                                                         onClose
                                                                     }: DropdownTypes) => {

    const [position, setPosition] = useState<DropdownPosition>({})
    const [isInitialRender, setIsInitialRender] = useState<boolean>(true);
    const prevBodyStyle = useRef<string>();
    placement = placement ?? "bottom-end"

    const ref = useRef(null);
    useOnClickOutside(ref, onClose, [anchorElement], !open)

    useEffect(() => {
        if (open) {
            setIsInitialRender(false);
        }
        if (anchorElement && open) {
            const rect = anchorElement.getBoundingClientRect();
            const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;
            const scrollBarHeight = window.innerHeight - document.documentElement.clientHeight;
            prevBodyStyle.current = document.body.getAttribute("style") ?? "";
            const currentPaddingRight = window.getComputedStyle(document.body).paddingRight;
            const newPaddingRight = `${parseInt(currentPaddingRight) + scrollBarWidth}`;
            const currentPaddingBottom = window.getComputedStyle(document.body).paddingBottom;
            const newPaddingBottom = `${parseInt(currentPaddingBottom) + scrollBarHeight}`;

            document.body.style.overflow = 'hidden';
            document.body.style.paddingRight = `${newPaddingRight}px`;
            document.body.style.paddingBottom = `${newPaddingBottom}px`;
            if (placement === "bottom-end") {
                setPosition({top: rect.top + rect.height, left: rect.right})
            } else {
                setPosition({left: rect.left, top: rect.bottom})
            }
        } else {
            document.body.setAttribute("style", prevBodyStyle.current ?? "");
        }
    }, [open])

    return !isInitialRender && <div
        ref={ref}
        style={{position: "fixed", ...position, zIndex: 2}}
        className={[styles.dropdownWrapper, placement === "bottom-end" ? styles.bottomEnd : styles.bottomStart, open && styles.open].join(" ")}>
        <ul>
            {children}
        </ul>
    </div>

}

const DropdownItem: FC<DropdownItemType> = ({ children, ...rest}) => {
    return <li {...rest} tabIndex={0}>{children}</li>
}

Dropdown.Item = DropdownItem;

export default Dropdown;
